




import app from "@/app";
import { SXSector } from "@/gobl.bundle";
import BaseComponent from "@/components/BaseComponent.vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class WSectorEdit extends BaseComponent {
	@Prop({ type: SXSector, required: true })
	sector!: SXSector;

	title = "SX_LANG_SECTOR_EDIT";

	get customData() {
		return this.ux_custom_data(this.sector.data);
	}
	get form() {
		return getForm(this.sector, this.customData);
	}

	sendForm(event: any) {
		let form: HTMLFormElement = event.target,
			required = [SXSector.COL_NAME, SXSector.COL_DESCRIPTION],
			fv = app.getFormValidator(form, required);

		if (fv.validate()) {
			let item = new SXSector(this.sector!.toObject()),
				data: any = {},
				customData = {
					...this.customData,
					bg_color: fv.getField("bg_color"),
					txt_color: fv.getField("txt_color")
				};

			data[SXSector.COL_DATA] = JSON.stringify(customData);

			[
				SXSector.COL_NAME,
				SXSector.COL_DESCRIPTION,
				SXSector.COL_VISIBILITY
			].forEach(function(name) {
				data[name] = fv.getField(name);
			});

			if (!fv.getField(SXSector.COL_VISIBILITY)) {
				data[SXSector.COL_VISIBILITY] = false;
			}

			if (!item.doHydrate(data).isClean()) {
				app.services.sectors.updateItem(item, function() {
					app.router.goBack();
				});
			} else {
				app.router.goBack();
			}
		}
	}
}

const getForm = function(sector: SXSector, custom_data: any) {
	return {
		fields: {
			name: {
				field: "input",
				label: { i18n: "SX_LANG_NAME" },
				attrs: {
					name: SXSector.COL_NAME,
					minlength: 3,
					maxlength: 60,
					autocomplete: "off",
					value: sector.name
				}
			},
			description: {
				field: "textarea",
				label: { i18n: "SX_LANG_DESCRIPTION" },
				attrs: {
					name: SXSector.COL_DESCRIPTION,
					minlength: 3,
					value: sector.description
				}
			},
			bg_color: {
				field: "input",
				label: { i18n: "SX_LANG_BG_COLOR" },
				attrs: {
					name: "bg_color",
					type: "color",
					value: custom_data["bg_color"] || "#233D7D"
				}
			},
			txt_color: {
				field: "input",
				label: { i18n: "SX_LANG_TXT_COLOR" },
				attrs: {
					name: "txt_color",
					type: "color",
					value: custom_data["txt_color"] || "#FFFFFF"
				}
			},
			visibility: {
				field: "checkbox",
				label: { i18n: "SX_LANG_VISIBILITY" },
				attrs: {
					name: SXSector.COL_VISIBILITY,
					checked: sector.visibility
				}
			},
			submit: {
				field: "submit",
				i18n: "OO_LANG_VALIDATE_BTN"
			}
		}
	};
};
